import { mapActions } from "vuex";

export const authMethods = mapActions(["logIn", "logOut"]);
